<template>
  <div class="modalWrapper">
    <div class="modalBlock">
      <div class="actionHeadline">
        {{
          getTranslation(
            $store,
            "Product",
            "display_name",
            product.id,
            product.name
          )
        }}
      </div>
      <div class="actionSubline"></div>
      <ListOverflowScroll
        ref="listOverflowScroll"
        :maxListHeight="maxListHeight"
      >
        <ItemList
          itemType="size"
          :itemsToShow="availableSizesSorted"
          :animate="false"
          :activeItem="product"
          @onItemClicked="confirm"
          :style="itemListStyle(availableSizesSorted)"
        ></ItemList>
      </ListOverflowScroll>
      <div class="actionsBlock">
        <div class="confirmBtn" @click="close">
          {{ $t("dialog.size.btn.deny") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getTranslation, itemListStyle } from "@/utils/helpers";
import ListOverflowScroll from "@/components/common/ListOverflowScroll";
import ItemList from "@/components/common/ItemList.vue";
export default {
  components: {
    ItemList,
    ListOverflowScroll
  },
  data() {
    return {
      maxListHeight: 1000
    };
  },
  props: {
    product: Object,
    menuOffset: Boolean,
    onConfirm: Function,
    onClose: Function
  },
  computed: {
    availableSizesSorted() {
      return this.product.available_sizes
        .slice()
        .sort((a, b) => a.order_by - b.order_by);
    }
  },
  methods: {
    itemListStyle,
    getTranslation,
    close() {
      this.$emit("onClose");
    },
    confirm(size) {
      this.$emit("onConfirm", size);
    }
  }
};
</script>
<style lang="scss" scoped>
.modalWrapper {
  display: flex;
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 1300;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0;
  padding: 0;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.modalBlock {
  z-index: 1300;
  display: flex;
  align-self: center;
  flex-direction: column;
  text-align: center;
  min-height: 550px;
  padding: 50px 60px;
  width: 95vw;
  color: black;
  justify-content: space-between;
  border-radius: var(--component_modals_selectSize_modalBlock_border-radius);
  background: var(--component_modals_selectSize_modalBlock_background);
  box-shadow: 0 0 50px #00000029;
}

.confirmBtn {
  width: 210px;
  height: 70px;
  color: var(--component_modals_selectSize_confirmBtn_color);
  letter-spacing: 1.84px;
  text-transform: var(--component_modals_selectSize_confirmBtn_text-transform);
  font-family: var(--component_modals_selectSize_confirmBtn_font-family);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--component_modals_selectSize_confirmBtn_font-size);
  border: var(--component_modals_selectSize_confirmBtn_border);
  border-radius: var(--component_modals_selectSize_confirmBtn_border-radius);
  opacity: 1;
  padding: var(--component_modals_selectSize_confirmBtn_padding);
}
.actionsBlock {
  width: 100%;
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
.actionHeadline {
  text-transform: var(
    --component_modals_selectSize_actionHeadline_text-transform
  );
  color: var(--component_modals_selectSize_actionHeadline_color);
  font-family: var(--component_modals_selectSize_actionHeadline_font-family);
  font-size: var(--component_modals_selectSize_actionHeadline_font-size);
}
.actionSubline {
  margin-top: 15px;
  margin-bottom: 30px;
  color: var(--component_modals_selectSize_actionSubline_color);
  font-family: var(--component_modals_selectSize_actionSubline_font-family);
  font-size: var(--component_modals_selectSize_actionSubline_font-size);
}
</style>
